<template>
  <div>
    <h1 class="outline--text">Sources and Rating</h1>
    <br>

    <v-card>
      <v-row class="mb-4" dense>
        <v-card-title>
          <v-text-field
            v-model="filters.domain"
            label="Domain"
            clearable
          ></v-text-field>
        </v-card-title>

        <v-card-title>
          <v-btn color="primary" class="mr-2" @click="fetchSourceRatings">
            Apply Filters
          </v-btn>
          <v-btn text @click="resetFilters"> Reset </v-btn>
        </v-card-title>
        <v-card-title v-if="canManage">
          <v-btn
            depressed
            rounded
            small
            outlined
            icon
            color="grey darken-1"
            style="float: right"
            class="my-5"
            @click="exportItems"
            ><v-icon> mdi-file-export-outline </v-icon></v-btn
          >
        </v-card-title>
      </v-row>

      <!-- Data loader -->
      <v-progress-linear
        v-if="isLoading"
        indeterminate
        color="primary"
        class="my-3"
      ></v-progress-linear>

      <v-data-table
        :headers="headers"
        :items="sourceRating"
        :search="search"
        :loading="isLoading"
        :no-data-text="
          isLoading ? 'Loading items...' : 'No Source Ratings found'
        "
        class="elevation-1"
      >
        <template v-slot:item.updated_at="{ item }">
          {{ item.updated_at }}
        </template>

        <template v-slot:item.actions="{ item }">
          <v-icon
            small
            color="blue"
            class="mr-2"
            @click="openUpdateDialog(item)"
            title="Update"
          >
            mdi-pencil
          </v-icon>
          <v-icon
            small
            color="red"
            class="mr-2"
            @click="deleteSuppressedEmail(item.email)"
            title="Delete"
          >
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </v-card>

    <v-snackbar v-model="showError" color="error" timeout="5000">
      {{ error }}
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="showError = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  FETCH_SOURCE_RATING,
  FETCH_SOURCE_RATING_FILE,
} from "@/store/modules/sourceRating/actions";
import { RESOURCE_SOURCE_RATING_MANAGEMENT } from "@/store/modules/admin/getters";
import acl from "@/mixin/acl";

export default {
  name: "SourceRatingPage",
  mixins: [acl],
  data() {
    return {
      search: "",
      showError: false,
      filters: {
        domain: "",
      },
      headers: [
        { text: "Domain", value: "main_domain" },
        { text: "Rating", value: "domain_rating" },
        { text: "Last Updated", value: "updated_at" },
      ],
      dialog: false,
      editedEmail: null,
      editedData: {
        comment: "",
        is_actively_suppressed: 1,
      },
    };
  },
  computed: {
    ...mapGetters("sourceRating", [
      "sourceRating",
      "isLoading",
      "hasError",
      "error",
    ]),
    canManage: function () {
      return this.hasAccess([RESOURCE_SOURCE_RATING_MANAGEMENT]);
    },
  },
  methods: {
    fetchSourceRatings() {
      const params = {
        domain: this.filters.domain || undefined,
        search: this.search || undefined,
      };

      Object.keys(params).forEach((key) => {
        if (
          params[key] === undefined ||
          params[key] === null ||
          params[key] === ""
        ) {
          delete params[key];
        }
      });

      this.$store
        .dispatch(`sourceRating/${FETCH_SOURCE_RATING}`, { params })
        .catch((error) => {
          console.error("Error fetching Source Ratings:", error);
          this.showError = true;
        });
    },
    exportItems() {
      const params = {
        domain: this.filters.domain,
        search: this.search,
      };
      Object.keys(params).forEach(
        (k) => (params[k] == null || params[k] === "") && delete params[k]
      );

      this.$store
        .dispatch(`sourceRating/${FETCH_SOURCE_RATING_FILE}`, params)
        .catch((error) => {
          console.error("Error exporting Source Ratings:", error);
          this.showError = true;
        });
    },
    resetFilters() {
      this.filters.domain = "";
      this.search = "";
      this.fetchSourceRatings();
    },
  },
  mounted() {
    this.fetchSourceRatings();
  },
  watch: {
    error(newVal) {
      if (newVal) {
        this.showError = true;
      }
    },
  },
};
</script>
